// @ts-nocheck
import { Navigate } from "react-router-dom"
import { DashboardClient } from "@/components/dashboard/DashboardClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function DashboardPage() {
  const { supabaseUser } = useAuth()
  if (!supabaseUser) return <Navigate to="/auth/login" replace />
  return <div className="container-app py-4"><DashboardClient userId={supabaseUser.id} /></div>
}